import { registerMessages } from "../../../i18n/runtime";
import { registerEn } from "./messages.en";
import { registerEs } from "./messages.es";
registerMessages("en", registerEn);
registerMessages("es", registerEs);
